(function () {
    'use strict';

    angular.module('swif.ui')
    .config(route);


    function AlertsController($scope, collections, dataService, userService, actionService, swifAlerter, settingsService){
        'ngInject';
        var settings = settingsService;
        console.log('init AlertsController');
        swifAlerter.loadAlertFilters();
        var filter = {};
        var contentTypeTitle = {};
        dataService.addExtraFilter(filter, 'extra', 'user_id', '=', userService.getAuthenticatedUser().uid);
        dataService.addExtraFilter(filter, 'extra', 'pre_recorded', '!=', true);
        dataService.sortOn(filter, 'id', 'DESC');
        collections.createOrUpdate('alerts', 'filter', filter)
        .then(function (filters) {
            $scope.filters = filters;
        });
        $scope.getContentTypeTitle = function (filter) {
            if (!filter.model_id) {
                return;
            }
            if (!contentTypeTitle[filter.model_id]) {
                var contentType = settings.getContentTypeFromModel(filter.model_id);
                contentTypeTitle[filter.model_id] = contentType.title;
            }
            return contentTypeTitle[filter.model_id];
        };
        $scope.toggleFilterAlert = function (filter) {
            filter.is_alert = !filter.is_alert;
            dataService.save('filter', filter.id, {id: filter.id, is_alert: filter.is_alert})
            .then(function () {
                swifAlerter.loadAlertFilters();
            });
        };
        $scope.preValidate = function (data) {
            if (data.action.id === 'addToAlerts' || data.action.id === 'rmFromAlerts') {
                data.model.is_alert = !data.model.is_alert;
            }
            return true;
        };
        $scope.callback = function (error, data) {
            $scope.filters.defaultActionCallback(error, data);
            swifAlerter.loadAlertFilters();
            if (data.action.id === 'addToAlerts' || data.action.id === 'rmFromAlerts') {
                $scope.filters.getItems();
            }
        };
    }

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/alert/table_view', {
            templateUrl: 'partials/ui/alert_table_view.html',
            controller: AlertsController,
            reloadOnSearch: false
        });
    }

})();
